module.exports = __webpack_public_path__ + "static/media/Digital_Sales_Assignment.d895ea42.jpg";